import React, { useState } from 'react';
import './styles.scss';

const more = '/static/images/pro-bidder-membership/More.png';
const less = '/static/images/pro-bidder-membership/Less.png';

interface Question {
    inquiry: string;
    answer: React.ReactNode;
}

interface FaqProps {
    questions: Question[];
}

const Faq: React.FC<FaqProps> = ({ questions }) => {
    const [visibleAnswerIndex, setVisibleAnswerIndex] = useState<number | null>(null);

    const toggleAnswer = (index: number) => {
        setVisibleAnswerIndex(visibleAnswerIndex === index ? null : index);
    };

    return (
        <div className="faq-main-div">
            {questions.map((question, idx) => {
                return (
                    <div onClick={() => toggleAnswer(idx)} key={idx} className="faq-container">
                        <div className="inquiry-container">
                            <p className="inquiry-header">{question.inquiry}</p>
                            <img
                                src={visibleAnswerIndex === idx ? less : more}
                                alt="Toggle Answer"
                                className={`faq-icon ${visibleAnswerIndex === idx ? 'faq-icon-less' : ''}`}
                            />
                        </div>
                        {visibleAnswerIndex === idx && (
                            <div className="inquiry-content">
                                {question.answer}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Faq;
